@if (layout_state.display_header) {
  <ts-header-bar
    class="d-contents"
    [navigate_to_dashboard]="layout_state.can_navigate_to_dashboard"
    [logo_url]="layout_state.logo_url"
  />
}
<div
  class="d-flex flex-column flex-grow-1 overflow-auto scrollbars-stable"
  [@routerAnimation]="o && o.isActivated && o.activatedRoute"
  (@routerAnimation.start)="onRouterAnimationStart($event)"
  #scrollableElement
>
  @if (
    layout_state.display_page_title &&
    (page_title_state.navigation_title || page_title_state.page_title || page_title_content)
  ) {
    <ts-fluid-page-title
      class="d-contents"
      [state]="page_title_state"
      [content]="page_title_content"
    />
  }

  <main class="d-flex flex-column flex-grow-1">
    <div #errorContainer>
      @if (error) {
        <ts-generic-error [error]="error" />
      }
    </div>
    <div #contentContainer>
      <router-outlet #o="outlet" />
    </div>
  </main>

  <ts-footer-bar class="d-contents" [company_name]="layout_state.tenant_name" />
</div>
